import { Enums } from "@flightscope/baseball-stats";
import PitchCallSeriesColorMapping from "./PitchCallSeriesColorMapping";


export default {
  ...PitchCallSeriesColorMapping,
  // [PitchCall.Ball.key]: 'blue',
  // [PitchCall.CalledStrike.key]: 'red',
  // [PitchCall.BallInPlay.key]: 'green',
  [Enums.PitchResultCombined.Ball.key]: 'blue',

  [Enums.PitchResultCombined.CalledStrike.key]: 'red',
  [Enums.PitchResultCombined.FieldOut.key]: 'black',

  [Enums.PitchResultCombined.SwingingStrike.key]: 'brown',


  [Enums.PitchResultCombined.CalledStrikeout.key]: 'teal',
  [Enums.PitchResultCombined.SwingingStrikeout.key]: 'teal',


  [Enums.PitchResultCombined.FoulOut.key]: 'red',
  [Enums.PitchResultCombined.FoulTipOut.key]: 'red',

  [Enums.PitchResultCombined.Single.key]: 'green',
  [Enums.PitchResultCombined.Double.key]: 'orange',
  [Enums.PitchResultCombined.Triple.key]: 'pink',
  [Enums.PitchResultCombined.HomeRun.key]: 'purple',

  [Enums.PitchResultCombined.Walk.key]: 'lightblue',
  [Enums.PitchResultCombined.IntentionalWalk.key]: 'lightblue',


};
